import { AreaTreeQuery } from 'src/client/generated';
import { ArrowForwardIcon } from 'src/client/components/common/icons';

type Props = {
  areaTreeData: AreaTreeQuery | undefined;
  setSelectedRegion: React.Dispatch<React.SetStateAction<string>>;
  setAreaModalUI: React.Dispatch<React.SetStateAction<'region' | 'prefectures'>>;
};

export const RegionList = ({ areaTreeData, setSelectedRegion, setAreaModalUI }: Props) => {
  return (
    <>
      <div className="mx-4">
        {areaTreeData?.areaTree.regions.map((o) => (
          <div
            className="w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray"
            key={o.id}
            id={o.id}
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              setSelectedRegion(e.currentTarget.id);
              setAreaModalUI('prefectures');
            }}
          >
            <span>{o.name}</span>
            <ArrowForwardIcon width={18} />
          </div>
        ))}
      </div>
    </>
  );
};
